import { validate } from 'ngrx-forms';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { WebUserService } from 'src/app/services/webuser.service';
import { IsLoggedInRequestAction } from 'src/app/store/common/common.actions';
import { StartupService } from '../../services/startup.service';
import { EMPTY } from 'rxjs';

@Injectable()
export class StartupEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: StartupService,
    private webUserService: WebUserService,
  ) {
  }

  login$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.StartupAction),
    switchMap((action: any) => this.service.validate(action.payload).pipe(
      map((data: any) => {
        return ActionsList.StartupCompletedAction({ payload: data.data });
      }),
      catchError(err => {
        return EMPTY;
      })
    )),
  ));

  checkAvailability$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.CheckAvailabilityRequestAction),
    switchMap((action: any) => this.webUserService.isMaintenanceMode().pipe(
      map((data: any) => {
        return ActionsList.CheckAvailabilityResponseAction({ payload: data });
      }),
      catchError(err => {
        return EMPTY;
      })
    )),
  ));

}
